import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * 전용 스타일이 적용된 커스텀 드롭다운 선택 컴포넌트.
 */
const CustomSelect = ({ value, options, onChange, icon: Icon, label, className = "" }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const selectedOption = options.find(opt => opt.value === value) || options[0];

    return (
        <div className={`relative w-full md:w-40 ${className}`} ref={dropdownRef}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className={`flex items-center justify-between w-full gap-2 bg-white border border-gray-200 rounded-full px-3 h-11 shadow-sm transition-all duration-200 hover:border-blue-300 hover:shadow-md ${isOpen ? 'ring-2 ring-inset ring-blue-100 border-blue-400' : ''} ${className}`}
            >
                <div className="flex items-center gap-2 overflow-hidden">
                    <Icon size={14} className={isOpen ? 'text-blue-500' : 'text-gray-400'} />
                    <span className="text-[14px] font-bold text-gray-700 whitespace-nowrap overflow-hidden text-ellipsis">
                        {selectedOption.label}
                    </span>
                </div>
                <ChevronDown size={14} className={`text-gray-300 transition-transform duration-200 flex-shrink-0 ${isOpen ? 'rotate-180 text-blue-400' : ''}`} />
            </button>

            {isOpen && (
                <div className="absolute top-full left-0 mt-2 w-full bg-white border border-gray-100 rounded-2xl shadow-xl z-50 py-2 animate-in fade-in slide-in-from-top-2 duration-200">
                    <div className="px-3 py-1 mb-1">
                        <span className="text-[13px] font-black text-gray-400 uppercase tracking-widest">{label}</span>
                    </div>
                    {options.map((option) => (
                        <button
                            key={option.value}
                            onClick={() => {
                                onChange(option.value);
                                setIsOpen(false);
                            }}
                            className={`w-full flex items-center justify-between px-4 py-2 text-[15px] transition-colors hover:bg-blue-50/50 ${value === option.value ? 'text-blue-600 font-bold bg-blue-50/30' : 'text-gray-600 font-medium'}`}
                        >
                            <span className="truncate">{option.label}</span>
                            {value === option.value && <div className="w-1.5 h-1.5 bg-blue-500 rounded-full shadow-[0_0_8px_rgba(59,130,246,0.5)]" />}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CustomSelect;
